<template>
  <div class="section-header">
    <el-row>
      <span class="title-text" :class="{ collapsible: collapsible }" @click="onTitleClick">
        <i v-if="collapsible" :class="collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" class="collapse-icon"></i>
        {{ title }}
      </span>
      <div class="slotted-content">
        <slot></slot>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "section-title",
  props: {
    title: String,
    collapsible: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onTitleClick() {
      if (this.collapsible) {
        this.$emit("toggle");
      }
    },
  },
};
</script>

<style scoped>
.section-header > .el-row {
  padding: 10px;
  background: #7cc156;
  color: white;
  font-weight: bolder;
  display: flex;
  align-items: center;
}
.section-header .title-text.collapsible {
  cursor: pointer;
  user-select: none;
}
.section-header .title-text .collapse-icon {
  margin-right: 5px;
}
.section-header > .el-row > .slotted-content {
  margin-left: auto;
}
</style>
<style>
.section-header > .el-row > .slotted-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.section-header > .el-row > .slotted-content .label {
  font-size: 0.85rem;
  margin: 0 5px;
}
.section-header > .el-row > .slotted-content .gap {
  margin-left: 25px;
}
</style>
